import { render, staticRenderFns } from "./AtrcNYearsNoClaims.vue?vue&type=template&id=08ba30de&scoped=true"
import script from "./AtrcNYearsNoClaims.vue?vue&type=script&lang=js"
export * from "./AtrcNYearsNoClaims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba30de",
  null
  
)

export default component.exports